import styled, { css } from "styled-components";
import { COLORS } from "../assets/utils/enums/colors";

export const boxShadow = ($color: string) => css`
  box-shadow: 0px 4px 4px 0 ${$color};
`;

export const BodyDiv = styled.div<{
  $isPadding?: boolean;
}>`
  ${boxShadow("rgba(9, 21, 64, 0.15)")};
  width: auto;
  min-height: 70vh;
  padding: 24px ${({ $isPadding }) => ($isPadding ? "24px" : "0px")};
  border-radius: 12px;
  background-color: ${COLORS.white};
`;

export const statusBtn = (
  $bgColor: string,
  $txtColor: string,
  $direction: string,
) => css`
  border: 1px solid ${$txtColor};
  background-color: ${$bgColor};
  color: ${$txtColor};
  display: flex;
  flex-direction: ${$direction};
  justify-content: space-between;
  padding: 4px;
  border-radius: 50px;
`;
